module.exports = __webpack_public_path__ + "img/bttn_blue_pin.c60b25ea.png";